import React, { ReactNode, useEffect, useState } from 'react';
import Sidebar from './Sidebar/Sidebar';
import Navbar from './Navbar/Navbar';
import {
  loadSidebarPinnedPreference,
  persistSidebarPinnedLocally,
  readStoredSidebarPinned,
  saveSidebarPinnedPreference,
  SIDEBAR_PINNED_CHANGE_EVENT,
} from '../../utilities/sidebarPreference';

interface DashboardLayoutProps {
  children: ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [isSidebarPinned, setIsSidebarPinned] = useState(readStoredSidebarPinned);

  useEffect(() => {
    const idUser = Number(localStorage.getItem('userid') ?? 0);
    let cancelled = false;

    if (!idUser) return;

    loadSidebarPinnedPreference(idUser)
      .then((pinned) => {
        if (cancelled) return;

        setIsSidebarPinned(pinned);
        persistSidebarPinnedLocally(pinned);
      })
      .catch((error) => {
        console.warn('Unable to load sidebar preference:', error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const handleSidebarPinnedChange = (event: Event) => {
      const { pinned } = (event as CustomEvent<{ pinned: boolean }>).detail;
      setIsSidebarPinned(pinned);
    };

    window.addEventListener(SIDEBAR_PINNED_CHANGE_EVENT, handleSidebarPinnedChange);

    return () => {
      window.removeEventListener(SIDEBAR_PINNED_CHANGE_EVENT, handleSidebarPinnedChange);
    };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarPinned((current) => {
      const next = !current;
      const idUser = Number(localStorage.getItem('userid') ?? 0);

      persistSidebarPinnedLocally(next);
      saveSidebarPinnedPreference(idUser, next).catch((error) => {
        console.warn('Unable to save sidebar preference:', error);
      });

      return next;
    });
  };

  return (
    <>
      <Sidebar isSidebarPinned={isSidebarPinned} onToggleSidebar={toggleSidebar} />
      <Navbar changNavbar={isSidebarPinned} onToggleSidebarInNavbar={toggleSidebar} />
      <div className={`content-page ${isSidebarPinned ? "content-page-push" : "content-page-pool"}`}>
        <div className="container-fluid">
          <div className="col-lg-12 m-0 p-0">{children}</div>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
